// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-3lJuDg4i clearfix","box_r":"box_r-j1rmdIRI","d_box":"d_box-1uKQF5TF"};